import categoryServices from "@/services/category";
import organizationServices from "@/services/organization";

const state = {
  allCategories: [],
};

const getters = {
  allCategories(state) {
    return state.allCategories;
  },
};

const mutations = {
  SET_ALL_CATEGORIES: (state, allCategories) => {
    state.allCategories = allCategories;
  },
};

const actions = {
  async setAllCategories({ commit }) {
    await categoryServices.list({
      offset: 0,
      limit: 999,
      locale: "vi",
      organization_id: organizationServices.getCurrentOrg()?.id
    }).then((response) => {
      commit("SET_ALL_CATEGORIES", response.items);
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
